import React, { Suspense } from 'react';
import { ComponentConfig } from '@measured/puck';
import {
  MarginProps,
  marginFields,
} from '../../../../page-builder/puck/reusable-props/NewMargin';
import { useCallback, useState } from 'react';
import {
  ErrorResponse,
  useNavigate,
  useLocation,
  useSearchParams,
} from 'react-router-dom';
import {
  ISelectedUpsellItems,
  postUpsellPurchasePayload,
} from '../../../../page-builder/interface/postUpsellInterface';
import checkoutService from '../../../api/checkoutService';
import {
  setErrorStatus,
  setIsLoading,
} from '../../../../page-builder/redux/slices/postUpsellStateSlice';
import {
  paddingFields,
  PaddingProps,
} from '../../../../page-builder/puck/reusable-props/padding';
import {
  ReduxDispatchProps,
  ReduxSelectorProps,
} from '../../../services/constants';
import { AxiosInstance } from 'axios';
import CustomTooltip from '../../../../components/common/tooltip';
import {
  getBorderProps,
  getcurrentDeviceType,
  getNewMarginStyles,
  getPaddingStyles,
  getQuillEditorText,
} from '../../../utils/helper';
import { QuillTextEditor } from '../../../puck/reusable-props/quill-editor';
import '../../text-editor/style.scss';
import { getIsViewIsEdit } from '../../../utils/constants';
import showComponent, {
  showComponentProps,
} from '../../../puck/reusable-props/showComponent';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../../puck/reusable-props/Border';
import { backgroungFields } from '../../../puck/reusable-props/backgroungFields';
import {
  setCurrentUpsellData,
  setSelectedUpsellItems,
} from '../../../redux/slices/postUpsellSlice';
import LoadingSpinner from '../../shared/LoadingSpinner';
import WidthAndHeight, {
  WidthAndHeightSubProps,
} from '../../../puck/reusable-props/widthAndHeight';
import { gradientFields } from '../../../puck/reusable-props/gradientColor';
const PostUpsellPayPal = React.lazy(() => import('../PostUpsell-PayPal'));
import { showNotification } from '../../../api/constant';

export type MultiProductAcceptButtonComponentPropsProps = {
  NextButton: string;
  border: IBorderValueProps;
  background: {
    color: string;
    isInherit: boolean;
  };
  widthAndHeight: WidthAndHeightSubProps;
  gradient: { isGradientChecked: boolean; color: string };
} & MarginProps &
  PaddingProps &
  showComponentProps;

export interface MultiProductAcceptButtonComponentProps
  extends ReduxSelectorProps,
    ReduxDispatchProps {
  baseService?: AxiosInstance;
}

export const MultiProductAcceptButton = ({
  useAppDispatch,
  useAppSelector,
}: MultiProductAcceptButtonComponentProps): ComponentConfig<MultiProductAcceptButtonComponentPropsProps> => {
  return {
    label: (
      <CustomTooltip title="Next Button">
        <span>Multi Product Accept Button</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
      NextButton: { ...QuillTextEditor('Button Text', false).content },
      widthAndHeight: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <WidthAndHeight
            value={value}
            onChange={val => {
              onChange(val);
            }}
            title={'Custom Button'}
            isfullWidth={true}
          />
        ),
      },
      ...backgroungFields,
      ...gradientFields,
    },
    defaultProps: {
      background: {
        color: '#ffffff',
        isInherit: false,
      },
      widthAndHeight: {
        height: {
          desktop: '100%',
          mobile: '100%',
          tablet: '100%',
        },
        maxWidth: {
          desktop: 'auto',
          mobile: 'auto',
          tablet: 'auto',
        },
        deviceType: 'desktop',
        fullWidth: {
          desktop: false,
          mobile: false,
          tablet: false,
        },
      },
      showComponent: ['desktop', 'tablet', 'mobile'],
      NextButton: `<h1><u style="color: rgb(0, 102, 204); font-size: 20px;">Continue</u></h1>`,
      margin: {
        deviceType: 'desktop',
        marginBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        marginLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        marginRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        marginTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      ...borderProps,
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      gradient: {
        isGradientChecked: false,
        color:
          'linear-gradient(90deg, rgba(255,0,0,1) 0%, rgba(0,0,255,1) 100%)',
      },
    },
    render: ({
      NextButton,
      margin,
      padding,
      showComponent,
      background,
      widthAndHeight,
      border,
      editMode,
      gradient,
    }) => {
      const dispatch = useAppDispatch();
      const navigate = useNavigate();
      const { pathname } = useLocation();
      const checkoutState = useAppSelector(state => state.checkout);
      const postUpsell = useAppSelector(state => state.postUpSell);
      const storeState = useAppSelector(state => state.store);
      const orderID = checkoutState.checkoutOrderID;
      const purchaseToken = checkoutState.purchaseToken;
      const storeData = storeState.storeData;
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getNewMarginStyles(margin, currentDeviceType);
      const [searchParams] = useSearchParams();
      const borderStyles = getBorderProps(border, currentDeviceType);
      const currentUpsellData = postUpsell?.currentUpsellData;
      const upsellData = postUpsell?.upsellData;
      const selectedUpsellItems = postUpsell?.selectedUpsellItems;

      const selectedProductsForMultiProducts =
        postUpsell?.selectedProductsForMultiProducts;
      const postUpsellState = useAppSelector(state => state.postUpSellState);
      const isApiLoading = postUpsellState?.isLoading;
      const [errorMessage, setErrorMessage] = useState('');

      const state = useAppSelector(state => state);
      const newNextButton = getQuillEditorText(NextButton, state);
      const newSearchParams = new URLSearchParams(searchParams.toString());
      const smartUpsellFunnelID = postUpsell?.smartUpsellFunnelID;
      const IsViewIsEdit = getIsViewIsEdit();
      const isUpsellFunnelPreview = searchParams.get('isUpsellFunnelPreview');
      const isCheckoutPaymentPaypal = useAppSelector(
        state => state.common.isPaymentByPaypal,
      );
      const IndependentTransactionForUpsellPages =
        storeData?.IndependentTransactionForUpsellPages ||
        isCheckoutPaymentPaypal ||
        false;
      let navState = {};
      if (!getIsViewIsEdit() && checkoutState?.nextpageConfig?.id) {
        navState = {
          state: checkoutState?.nextpageConfig?.id
            ? {
                id: checkoutState?.nextpageConfig?.id,
                pageVisiblity: checkoutState?.nextpageConfig?.pageVisiblity,
                pageType: checkoutState?.nextpageConfig?.pageType,
              }
            : {},
        };
      }

      const navigateFunctionToThankYouPage = useCallback(() => {
        if (checkoutState?.nextpageConfig?.id) {
          navigate(pathname + '?' + newSearchParams.toString(), navState);
        }
      }, [
        checkoutState.nextpageConfig?.id,
        checkoutState.nextpageConfig?.pageVisiblity,
      ]);

      let acceptNavState = {};
      if (
        !getIsViewIsEdit() &&
        upsellData?.[currentUpsellData?.accept?.nextProduct]?.pageId
      ) {
        acceptNavState = {
          state: upsellData?.[currentUpsellData?.accept?.nextProduct]?.pageId
            ? {
                id: upsellData?.[currentUpsellData?.accept?.nextProduct]
                  ?.pageId,
                pageVisiblity: '',
                pageType: 'upsell',
              }
            : {},
        };
      }

      const navigateUpsellFunction = useCallback(() => {
        if (upsellData?.[currentUpsellData?.accept?.nextProduct]?.pageId) {
          navigate(pathname + '?' + newSearchParams.toString(), acceptNavState);
        }
      }, [upsellData?.[currentUpsellData?.accept?.nextProduct]?.pageId]);
      const openEditor = async () => {
        const newPageID =
          upsellData?.[currentUpsellData?.accept?.nextProduct]?.pageId;
        const updatedSearchParams = new URLSearchParams(
          searchParams.toString(),
        );
        updatedSearchParams.set('pageID', String(newPageID));
        navigate(pathname + '?' + updatedSearchParams.toString());
      };
      const isNavToThankyouPage = !currentUpsellData?.accept?.nextProduct;

      const handleCompletePurchase = useCallback(
        async (
          selectedItems: ISelectedUpsellItems[],
          isNavToThankyouPage: boolean,
        ) => {
          if (isCheckoutPaymentPaypal) return;
          if (selectedItems.length === 0) {
            navigateFunctionToThankYouPage();
            return;
          }

          const payload: postUpsellPurchasePayload = {
            LineItems: selectedItems
              .filter(item => item)
              .map(item => ({
                Quantity: 1,
                VariantID: item.variantId,
                UpsellDetails: {
                  GroupId: item.GroupId,
                  IsDownsell: item.IsDownsell,
                  DownsellId: item.IsDownsell ? (item.DownsellId ?? '') : '',
                  ProductId: item.ProductId,
                },
              })),
            OrderID: orderID,
            PurchaseToken: purchaseToken,
            FunnelId: Number(smartUpsellFunnelID),
            ShopID: storeData?.ShopID,
            StoreID: storeData?.StoreID || '',
          };

          try {
            const res = await checkoutService.postUpsellPurchase(payload);

            if (res.status === 200) {
              dispatch(setIsLoading(false));
              if (isNavToThankyouPage) navigateFunctionToThankYouPage();
            }
          } catch (error: unknown) {
            const err = error as ErrorResponse;
            if (err.status === 400) {
              dispatch(setIsLoading(false));
              if (isNavToThankyouPage) navigateFunctionToThankYouPage();
              dispatch(setErrorStatus(err.status));
              throw error;
            } else {
              dispatch(setIsLoading(false));
              if (isNavToThankyouPage) navigateFunctionToThankYouPage();
              throw error;
            }
          }
        },
        [
          navigate,
          navigateFunctionToThankYouPage,
          orderID,
          purchaseToken,
          storeData,
        ],
      );
      async function handleClick() {
        if (IsViewIsEdit && !!isUpsellFunnelPreview) {
          if (currentUpsellData?.accept?.nextProduct) {
            await openEditor();
            dispatch(
              setCurrentUpsellData(
                upsellData?.[currentUpsellData?.accept?.nextProduct],
              ),
            );
          } else if (!currentUpsellData?.decline?.nextProduct) {
            showNotification('success', 'Upsell flow ended here');
          }
        } else {
          dispatch(setIsLoading(true));
          if (selectedProductsForMultiProducts.length === 0) {
            dispatch(setIsLoading(false));
            setErrorMessage('Please select at least one product.');
            setTimeout(() => {
              setErrorMessage('');
            }, 5000);
            return;
          }

          if (!currentUpsellData?.accept?.nextProduct) {
            try {
              IndependentTransactionForUpsellPages
                ? await handleCompletePurchase(
                    selectedProductsForMultiProducts,
                    true,
                  )
                : await handleCompletePurchase(
                    [
                      ...selectedUpsellItems,
                      ...selectedProductsForMultiProducts,
                    ],
                    true,
                  );
              dispatch(setIsLoading(false));
            } catch (error) {
              dispatch(setIsLoading(false));
            }
          } else {
            if (IndependentTransactionForUpsellPages)
              handleCompletePurchase(selectedProductsForMultiProducts, false);
            navigateUpsellFunction();
            dispatch(
              setSelectedUpsellItems([
                ...selectedUpsellItems,
                ...selectedProductsForMultiProducts,
              ]),
            );
            dispatch(
              setCurrentUpsellData(
                upsellData?.[currentUpsellData?.accept?.nextProduct],
              ),
            );
            dispatch(setIsLoading(false));
          }
        }
      }
      async function handleClickPayPal() {
        if (currentUpsellData?.accept?.nextProduct) {
          navigateUpsellFunction();
          dispatch(
            setCurrentUpsellData(
              upsellData?.[currentUpsellData?.accept?.nextProduct],
            ),
          );
        }
      }
      const containerStyle: React.CSSProperties = {
        background: gradient?.isGradientChecked
          ? gradient?.color
          : background?.isInherit
            ? 'inherit'
            : background?.color,
      };
      const buttonSize: React.CSSProperties =
        currentDeviceType &&
        widthAndHeight.maxWidth &&
        widthAndHeight.height &&
        widthAndHeight.maxWidth[currentDeviceType] !== undefined &&
        widthAndHeight.height[currentDeviceType] !== undefined
          ? {
              width: widthAndHeight?.fullWidth?.[currentDeviceType]
                ? '100%'
                : isNaN(+widthAndHeight.maxWidth[currentDeviceType])
                  ? widthAndHeight.maxWidth[currentDeviceType]
                  : `${+widthAndHeight.maxWidth[currentDeviceType]}px`,

              height: isNaN(+widthAndHeight.height[currentDeviceType])
                ? widthAndHeight.height[currentDeviceType]
                : `${+widthAndHeight.height[currentDeviceType]}px`,
            }
          : {};
      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <div
              style={{
                ...marginStyles,
                ...borderStyles,
                ...getPaddingStyles(padding, currentDeviceType),
              }}
              className={`flex w-full h-full relative text-editor-content flex-col ${border?.borderStyle?.[currentDeviceType]}`}>
              {isCheckoutPaymentPaypal &&
              selectedProductsForMultiProducts.length != 0 ? (
                <Suspense
                  fallback={
                    <button className="px-3 py-1.5 rounded-md bg-gray-400 text-white text-sm animate-pulse w-32 h-10" />
                  }>
                  <div
                    style={{ width: buttonSize.width }}
                    className={`mx-auto`}>
                    <PostUpsellPayPal
                      selectedItems={[...selectedProductsForMultiProducts]}
                      purchaseToken={purchaseToken}
                      buttonSize={buttonSize}
                      handleClick={handleClickPayPal}
                      storeData={storeData}
                      navigateToConfirmationPage={
                        navigateFunctionToThankYouPage
                      }
                      smartUpsellFunnelID={smartUpsellFunnelID}
                      useAppDispatch={useAppDispatch}
                      isNavToThankyouPage={isNavToThankyouPage}
                    />
                  </div>
                </Suspense>
              ) : (
                <>
                  <button
                    disabled={isApiLoading}
                    onClick={() => handleClick()}
                    className={`mx-auto`}
                    style={{
                      lineHeight: 1.5,
                      ...containerStyle,
                      ...buttonSize,
                    }}
                    dangerouslySetInnerHTML={{
                      __html: newNextButton,
                    }}></button>
                  {isApiLoading && (
                    <div className="absolute inset-0 cursor-not-allowed flex justify-center items-center bg-white bg-opacity-90">
                      <div className="h-9">
                        <LoadingSpinner />
                      </div>
                    </div>
                  )}
                  {errorMessage && (
                    <div className="text-red-500 text-center mt-2 text-sm">
                      {errorMessage}
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </>
      );
    },
  };
};
